import React from 'react';
import Card from 'src/components/card';
import i18n from 'src/utils/translate';
import { trackFootfallEventWithHrefDelay, trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';

class TopicList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
    };
  }
  render() {
    const { topics, community } = this.props;
    const sortedTopics = [...topics].sort((a, b) => b.postCount - a.postCount);
    const topicList = this.state.showAll ? sortedTopics : sortedTopics.splice(0, 5);
    const totalCount = topics.reduce((total, c) => total + c.postCount, 0);
    return (
      <Card title={i18n.t('Topics')}>
        <div className="sidebar__list">
          <a className="sidebar__list__link" href={`/${community.slug}/posts`}>
            {i18n.t('All posts')} ({totalCount})
          </a>
        </div>
        {topicList.map(c => (
          <div className="sidebar__list" key={c.id}>
            <a
              className="sidebar__list__link"
              href={`/${community.slug}/posts/topic/${c.name.toLowerCase()}`}
              onClick={e => {
                e.preventDefault();
                trackFootfallEventWithHrefDelay(
                  `/${community.slug}/posts/topic/${encodeURIComponent(c.name.toLowerCase())}`,
                  footfallEventTypes.CLICKED,
                  {
                    clickType: 'post-side-bar',
                    clickMetadata: {
                      section: 'post-side-bar',
                      element: 'topic',
                    },
                  },
                );
              }}
            >
              {c.name} ({c.postCount})
            </a>
          </div>
        ))}
        {!this.state.showAll && topics.length > 5 && (
          <a
            className="sidebar__show-more-btn"
            href="#"
            onClick={e => {
              e.preventDefault();
              this.setState({ showAll: true });
              trackFootfallEvent(footfallEventTypes.CLICKED, {
                clickType: 'post-side-bar',
                clickMetadata: {
                  section: 'post-side-bar',
                  element: 'see-all-topics',
                },
              });
            }}
          >
            {i18n.t('See all topics')} <span className="icon icon-down-open" />
          </a>
        )}
      </Card>
    );
  }
}

export default TopicList;
